<div class="container-modal-lateral">
  <div>
    <span class="title-modal-lateral">Filtrar</span>

    <div class="filtro">
      <app-select-multiple widthFormField="100%" heightFormField="35px" label="Número" backgroundColor="transparent" campo="nome" subCampo="numero" placeholder="Selecione"
                           [listaInput]="contas" [itensSelecionado]="filtro.numero" (selecionarItem)="filtro.numero = $event"></app-select-multiple>
      <app-select-multiple widthFormField="100%" heightFormField="35px" label="Canal" backgroundColor="transparent" campo="nome" placeholder="Selecione"
                           [listaInput]="listaCanal" [itensSelecionado]="filtro.canal" (selecionarItem)="filtro.canal = $event"></app-select-multiple>
      <app-select-multiple widthFormField="100%" heightFormField="35px" label="Tipos" backgroundColor="transparent" placeholder="Selecione"
                           [listaInput]="listaTipo" [itensSelecionado]="filtro.tipo" (selecionarItem)="filtro.tipo = $event"></app-select-multiple>
      <app-select-multiple widthFormField="100%" heightFormField="35px" label="Status" backgroundColor="transparent" campo="nome" placeholder="Selecione"
                           [listaInput]="listaStatus" [itensSelecionado]="filtro.status" (selecionarItem)="filtro.status = $event"></app-select-multiple>
      <app-select-multiple widthFormField="100%" heightFormField="35px" label="Status Meta" backgroundColor="transparent" placeholder="Selecione"
                           [listaInput]="listaStatusMeta" [itensSelecionado]="filtro.statusMeta" (selecionarItem)="filtro.statusMeta = $event"></app-select-multiple>
      <app-select-multiple widthFormField="100%" heightFormField="35px" label="Setor" backgroundColor="transparent" campo="nome" placeholder="Selecione"
                           [listaInput]="setores" [itensSelecionado]="filtro.setores" (selecionarItem)="filtro.setores = $event"></app-select-multiple>
    </div>
  </div>

  <div class="botoes-modal-lateral">
    <app-button-padrao
      width="100%"
      label="Filtrar"
      backgroundColor="var(--verde-padrao)"
      color="white"
      (buttonClick)="filtrar()">
    </app-button-padrao>
    <app-button-padrao
      width="100%"
      label="Cancelar"
      backgroundColor="white"
      color="var(--vermelho-padrao)"
      (buttonClick)="cancelar()"
      borderColor="var(--vermelho-padrao)"
      borderStyle="solid"
      borderWidth="1px">
    </app-button-padrao>
  </div>
</div>
